/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import * as React from "react";
import * as Sentry from "@sentry/react";
import { useParams } from "react-router-dom";
import Button from "../../../components/Layout/Button";
import Modal from "../../../components/Modal/Modal";
import Typography from "../../../components/Typography/Typography";
import InputField from "../../../components/Layout/fieldInput/InputField";
import { SERVICES } from "../../../components/Layout/Services";
import {
  get,
  post,
  postFormData,
} from "../../../components/Layout/ApiHandler/apihandler";
import { ToastAlertContext } from "../../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../../contants";

export default function UploadReceiptModal({
  open,
  onClose,
  uploadId,
  getBankDetails,
}) {
  const [attachments, setAttachments] = React.useState([]);
  const [attachmentsData, setAttachmentsData] = React.useState([]);
  const attachmentInputRef = React.useRef(null);
  const toast = React.useContext(ToastAlertContext);
  const [file, setFile] = React.useState(null);
  const [fileCheque, setFileCheque] = React.useState(null);
  const [fileDD, setFileDD] = React.useState(null);
  const handleAttachments = async (event) => {
    const file = event?.target?.files[0];
    setFile(file);
  };
  const handleAttachmentsCheques = async (event) => {
    const file = event?.target?.files[0];
    setFileCheque(file);
  };
  const handleAttachmentsDD = async (event) => {
    const file = event.target.files[0];
    setFileDD(file);
  };
  const handleSubmit = async () => {
    if (file || fileCheque || fileDD) {
      const allowedFileTypes = ["application/pdf", "image/png", "image/jpeg"];
      if (
        (file && !allowedFileTypes.includes(file.type)) ||
        (fileCheque && !allowedFileTypes.includes(fileCheque.type)) ||
        (fileDD && !allowedFileTypes.includes(fileDD.type))
      ) {
        toast.show("Selected slip format is not supported", AlertStatus.ERROR);
        return;
      }

      try {
        const formData = new FormData();
        // formData.append("file", file);
        // This code may use after getting api
        if (file) {
          formData.append("file", file);
        }
        if (fileCheque) {
          formData.append("sameBankChequeFile", fileCheque);
        }
        if (fileDD) {
          formData.append("diffBankChequeFile", fileDD);
        }
        const url = `${SERVICES.OFFLINE_BANK_DEPOSIT}/${uploadId}/bankDepositReceipt`;
        const response = await postFormData(url, formData);
        if (response.code === 200) {
          const { data } = response;
          toast.show("Slip Attached Successfully", AlertStatus.SUCCESS);
          onClose();
          await getBankDetails();
        }
      } catch (error) {
        toast.show(
          "Error uploading slip. Please try again.",
          AlertStatus.ERROR,
        );
      }
    } else {
      toast.show("No slip selected.", AlertStatus.ERROR);
    }
  };
  // console.log("cashFile", file);
  // console.log("chequeFile", fileCheque);
  // console.log("ddFile", fileDD);
  return (
    <Box tabIndex="0">
      <Modal open={open} onClose={onClose}>
        <Typography
          style={{
            fontSize: "20px ",
            fontWeight: "500",
            paddingBottom: "10px",
          }}
        >
          Upload Bank Stamped Deposit Slips
        </Typography>
        <Typography
          style={{
            fontSize: "18px ",
            fontWeight: "500",
            color: "red",
            paddingBottom: "20px",
          }}
        >
          Total upload filesize should be 1MB or less.
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            width: "400px",
          }}
        >
          <Typography
            style={{
              fontSize: "15px ",
              fontWeight: "200",
              // paddingBottom: "10px",
            }}
          >
            Upload Cash Deposit Slip
          </Typography>
          <input
            type="file"
            onChange={handleAttachments}
            ref={attachmentInputRef}
          />
          <Typography
            style={{
              fontSize: "15px ",
              fontWeight: "200",
              // paddingBottom: "10px",
            }}
          >
            Upload Cheque/DD (Same Bank) Slip
          </Typography>
          <input
            type="file"
            onChange={handleAttachmentsCheques}
            ref={attachmentInputRef}
          />
          <Typography
            style={{
              fontSize: "15px ",
              fontWeight: "200",
              // paddingBottom: "10px",
            }}
          >
            Upload Cheque/DD (Different Bank) Slip
          </Typography>
          <input
            type="file"
            onChange={handleAttachmentsDD}
            ref={attachmentInputRef}
          />
        </Box>
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <Button
            onClick={handleSubmit}
            width="40%"
            style={{
              marginRight: "10px",
            }}
          >
            Yes
          </Button>
          <Button
            onClick={onClose}
            cancel
            width="40%"
            style={{
              marginRight: "10px",
            }}
          >
            No
          </Button>
        </Box>
      </Modal>
    </Box>
  );
}
